cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_aroundstock_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			common.initRegionAndPosition(viewmodel);
			viewmodel.on("afterInit", function() {
				debugger
				//参照过滤掉服务商品
				var conditionProduct = {
					"isExtend": true,
					simpleVOs: []
				};
				conditionProduct.simpleVOs.push({
					field: 'virtualProductAttribute',
					op: 'eq',
					value1: 0
				});
				viewmodel.get('product.cName').getFromModel().setFilter(conditionProduct);
				viewmodel.get('productsku.skuName').getFromModel().setFilter(conditionProduct);

		        //门店过滤
		        viewmodel.get("store_name").getFromModel().on('beforeBrowse', function (data) {
		          //只能参照到当前用户有权限的门店
		          var userStores = cb.rest.AppContext.user.userStores;
		          var store_ids = [];
		          if (userStores != null && userStores != "" && userStores.length != 0) {
		            for (var i = 0; i < userStores.length; i++) {
		              store_ids.push(userStores[i].store);
		            }
		            var conditionStore = {
		              "isExtend": true,
		              simpleVOs: []
		            };
		            conditionStore.simpleVOs.push({
		              field: 'id',
		              op: 'in',
		              value1: store_ids
		            });
		            viewmodel.get('store_name').getFromModel().setFilter(conditionStore);
		          } else {
		            cb.utils.alert("无门店权限！", 'error');
		            return false;
		          }
		        });			
			});			
		}
	}
	try {
		module.exports = ST_st_aroundstock_filterVM_Extend;
	} catch(error) {
	}
	return ST_st_aroundstock_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_aroundstock_filterVM.Extend.js